module.exports = __webpack_public_path__ + "img/fachada-embali.a684893d.jpg";